var _defs, _rect, _rect2, _circle, _path, _circle2, _rect3, _rect4, _circle3, _path2, _path3, _path4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveLectures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 30 320 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "llGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "llGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "llGrad3",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f17067"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 45,
    width: 200,
    height: 140,
    rx: 8,
    fill: "url(#llGrad1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 55,
    width: 180,
    height: 120,
    rx: 4,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 115,
    r: 38,
    fill: "url(#llGrad2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207,95 L242,115 L207,135 Z",
    fill: "url(#llGrad3)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 72,
    r: 8,
    fill: "#e53935"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 185,
    width: 16,
    height: 45,
    fill: "url(#llGrad2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 226,
    width: 80,
    height: 12,
    rx: 5,
    fill: "url(#llGrad3)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 135,
    r: 28,
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,305 L30,215 Q30,175 75,175 Q120,175 120,215 L120,305 Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105,200 L160,160",
    stroke: "#414042",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15,245 L135,245 L125,315 L25,315 Z",
    fill: "url(#llGrad1)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 238,
    width: 130,
    height: 12,
    rx: 4,
    fill: "url(#llGrad3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLectures);
export default __webpack_public_path__ + "static/media/LiveLectures.7b85f2b12426c0e2ee7fd8061cdaf64f.svg";
export { ForwardRef as ReactComponent };